import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createVNode as _createVNode, renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "journey",
  "aria-label": "Application process"
}
const _hoisted_2 = { class: "journey__viewport" }
const _hoisted_3 = { class: "journey__rail" }
const _hoisted_4 = { class: "journey__label" }
const _hoisted_5 = {
  class: "journey__marker",
  "aria-hidden": "true"
}
const _hoisted_6 = { class: "journey__date" }
const _hoisted_7 = {
  key: 0,
  class: "journey__footer"
}
const _hoisted_8 = ["aria-expanded"]
const _hoisted_9 = {
  key: 0,
  class: "journey__form"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ol", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.renderedStages, (stage) => {
          return (_openBlock(), _createElementBlock("li", {
            key: stage.label,
            class: _normalizeClass(["journey__stage", {
            'journey__stage--reached': stage.reached,
            'journey__stage--current': stage.current,
            'journey__stage--connector-reached': stage.connectorReached,
          }]),
            style: _normalizeStyle({
            '--stage-color': stage.color,
            '--stage-soft-color': stage.softColor,
          })
          }, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(stage.label), 1),
            _cache[1] || (_cache[1] = _createElementVNode("span", {
              class: "journey__line",
              "aria-hidden": "true"
            }, null, -1)),
            _createElementVNode("span", _hoisted_5, [
              (stage.reached)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    icon: "check"
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("span", _hoisted_6, _toDisplayString(stage.date ? $setup.formatStageDate(stage.date) : ''), 1)
          ], 6))
        }), 128))
      ])
    ]),
    ($props.currentStatus || $props.toggleable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          ($props.currentStatus)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "journey__current",
                style: _normalizeStyle({ '--current-stage-color': $setup.currentStageColor })
              }, [
                _cache[2] || (_cache[2] = _createElementVNode("span", {
                  class: "journey__current-dot",
                  "aria-hidden": "true"
                }, null, -1)),
                _createTextVNode(" " + _toDisplayString($props.currentStatus), 1)
              ], 4))
            : _createCommentVNode("", true),
          ($props.toggleable)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "journey__toggle",
                "aria-expanded": $props.expanded,
                "aria-controls": "application-step-panel",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle')))
              }, [
                _cache[3] || (_cache[3] = _createElementVNode("span", null, "Next step", -1)),
                _createVNode(_component_font_awesome_icon, {
                  icon: "chevron-down",
                  class: _normalizeClass({ 'journey__toggle-icon--open': $props.expanded })
                }, null, 8, ["class"])
              ], 8, _hoisted_8))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "journey-form" }, {
      default: _withCtx(() => [
        ($props.expanded && $props.toggleable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _renderSlot(_ctx.$slots, "form", {}, undefined, true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}